<template>
  <!-- xss(htmlContentCopy, xssOptions) -->
    <div ref="richTextRef" v-html="htmlContentCopy" :class="classTag"></div>
</template>
<script setup lang="ts">
import xss from 'xss'
import { xssOptions } from '~/utils/format'
import { handleNewDetail, lazyLoadHtmlImages } from '~/utils/format'
import { ref, onMounted } from 'vue'
import defaultImg from '~/assets/images/placeholder-error.webp'
const props = defineProps({
    htmlContent: {
        type: String,
        default: () => ("<div>***</div>")
    },
    classTag: {
        type: String,
        default: () => ("")
    }
})
const richTextRef = ref(null)
onMounted(() => {
  // 获取所有图片元素
  const images = richTextRef.value?.querySelectorAll('img')
  if (images) {
    images.forEach(img => {
      // 设置默认图片
    //   img.dataset.src = img.src // 保存原始 src
      img.onerror = function() {
        this.src = defaultImg // 设置默认图片
        this.onerror = null // 防止无限循环
      }
    })
  }
})
let htmlContentCopy = JSON.parse(JSON.stringify(props.htmlContent))
htmlContentCopy = handleNewDetail(htmlContentCopy)
// nextTick(() => {
//     setTimeout(() => {
//       // 不再使用原生的lazy加载，使用loading='lazy'
//         // lazyLoadHtmlImages('.' + props.classTag)
//     }, 100) // 给一点时间让DOM更新
// })
</script>